// extracted by css-extract-rspack-plugin
export default {"root":"Evqg55Th_YCWabvo"};